/**
 * Convert a base64 string in a Blob according to the data and contentType.
 * 
 * @param b64Data {String} Pure base64 string without contentType
 * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
 * @param sliceSize {Int} SliceSize to process the byteCharacters
 * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
 * @return Blob
 */

let b64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, {
        type: contentType
    });
    return blob;
}
// File size validator (max 5MiB)
$.validator.addMethod(
  "maxfilesize",
  function (value, element) {
    if (this.optional(element) || ! element.files || ! element.files[0]) {
      return true;
    } else {
      return element.files[0].size <= 1024 * 1024 * 5;
    }
  },
  'The file size can not exceed 5MiB.'
);

$(document).ready(function(){
  let validateForm = $(".closer-books-customizer-form").validate({
    ignore: [],
    rules: {
        title: {
            required: function() {
                return true;
            }
        },
        subTitle: {
            required: function() {
            // Only required when subtitle is enabled. If the product disables
            // subtitle (`subTitleEnabled === false`) make this optional.
            return window.customBook ? window.customBook.subTitleEnabled !== false : true;
            }
        },
        subTitle2: {
            required: function() {
            // Only required when subtitle2 is enabled. If the product disables
            // subtitle (`subTitle2Enabled === false`) make this optional.
            return window.customBook ? window.customBook.subTitle2Enabled !== false : true;
            }
        },
        uploadedImage : {
          required: () => {
            // Only required when the uploader is visible AND there is no image
            const uploaderVisible = $(`[data-uploadedImage]:visible`).length > 0;
            if (!uploaderVisible) return false;

            // Check several indicators for an existing image which should satisfy the requirement
            const inputVal = $(`[data-uploadedImage]`).val();
            const previewSrc = $(`[data-uploadedImage-container] #userPreview`).attr('src') || '';
            const fullSrc = $('#uploadedImageFullSize').attr('src') || '';
            const modelHasImage = window.customBook && (window.customBook.uploadedImage || window.customBook.uploadedImageFullSizeDataURL);

            // If any image source exists, the field is not required
            if (inputVal || previewSrc || fullSrc || modelHasImage) return false;

            // Visible and no image found -> required
            return true;
          },
          maxfilesize: () => {
           return true;
          }
        },
        
    },
    messages: {
        title: "Please enter a title.",
        subTitle: "Please enter a subtitle.",
        subTitle2: "Please enter a second subtitle.",
        uploadedImage: {
          required: "Please upload a photo.",
          maxfilesize: function (_param, element) {
            const file = element && element.files && element.files[0];
            if (!file) return 'The file size can not exceed 5MiB.';
            const bytes = file.size;
            const mb = bytes / (1024 * 1024);
            const human = mb >= 1 ? mb.toFixed(2) + ' MB' : Math.round(bytes / 1024) + ' KB';
            return `Your file size ${human}. Please choose a file within 5 MB.`;
          },
        },
    },
    submitHandler: function(form) {

    },
     errorPlacement : function(error, element) {
       let currentName = $(element).attr('name');
       
       if(currentName == "title") {
         $(`[data-error="title"]`).html(error);
       } else if(currentName == "subTitle") {
         $(`[data-error="subTitle"]`).html(error);
       } else if(currentName == "subTitle2") {
         $(`[data-error="subTitle2"]`).html(error);
       } else if(currentName == "uploadedImage") {
         $(`[data-error="uploadedImage"]`).html(error);
       } else {
         error.insertAfter(element);
       }
     },
    highlight: function(element, errorClass, validClass) {
        let currentName = $(element).attr('name');
        let errorCustomClass = `textbox-red-error`;
        if(currentName == "title") {
          $(`[name="title"]`).addClass(errorCustomClass);
          $(`[data-error="title"]`).show();
        }
        if(currentName == "subTitle") {
          $(`[name="subTitle"]`).addClass(errorCustomClass);
          $(`[data-error="subTitle"]`).show();
        }
        if(currentName == "subTitle2") {
          $(`[name="subTitle2"]`).addClass(errorCustomClass);
          $(`[data-error="subTitle2"]`).show();
        }
        
        if(currentName == "uploadedImage") {
          $(element).parents(`.img-upload`).eq(0).addClass(errorCustomClass);
          $(`[data-uploadedImage]`).addClass(errorCustomClass);
          $(`[data-error="uploadedImage"]`).show();
        }
    },
    unhighlight: function(element, errorClass, validClass) {
      let currentName = $(element).attr('name');
      let errorCustomClass = `textbox-red-error`;
      if(currentName == "title") {
        $(`[name="title"]`).removeClass(errorCustomClass);
        $(`[data-error="title"]`).hide();
      }
      if(currentName == "subTitle") {
        $(`[name="subTitle"]`).removeClass(errorCustomClass);
        $(`[data-error="subTitle"]`).hide();
      }
      if(currentName == "subTitle2") {
        $(`[name="subTitle2"]`).removeClass(errorCustomClass);
        $(`[data-error="subTitle2"]`).hide();
      }
      if(currentName == "uploadedImage") {
        $(element).parents(`.img-upload`).eq(0).removeClass(errorCustomClass);
        $(`[data-uploadedImage]`).removeClass(errorCustomClass);
        $(`[data-error="uploadedImage"]`).hide();
      }
    }
  }
  );

  const $form = $('.closer-books-customizer-form');

  const validator = $form.validate();

  let currentStep = 0;
  const $steps = $('.step');
  const totalSteps = $steps.length;
  const $progressSteps = $('.progress-block');

  // Call initialization on page load
  initializeBundleState();

  /** @param {number} index */
  async function showStep(index) {
    // Clamp index to valid range
    if (typeof index !== 'number') index = 0;
    if (index < 0) index = 0;
    if (index > totalSteps - 1) index = totalSteps - 1;

    const bundle = await getBundleState();

    // Determine allowed last step for per-book flow. When running a bundle and
    // the current book is NOT the last one, hide/skip the absolute final
    // 'upgrades' step (which is the last step in the UI). In that case the
    // last allowed step for the book is `totalSteps - 2`.
    let allowedLastStep = totalSteps - 1;
    if (bundle && bundle.isBundle && bundle.currentIndex < bundle.bundleSize - 1) {
      allowedLastStep = Math.max(0, totalSteps - 2);
    }

    // If the requested index is beyond the allowed step for this context,
    // clamp it so users cannot navigate to the upgrades step until the last
    // bundle item.
    if (index > allowedLastStep) index = allowedLastStep;

    $steps.hide().removeClass("active");
    $steps.eq(index).show().addClass("active");
    $progressSteps.removeClass("active");
    for (let i = 0; i <= index; i++) {
      $progressSteps.eq(i).addClass("active");
    }
    // console.log('currentStep - ', currentStep);
    // console.log('bundle.currentIndex ', bundle ? bundle.currentIndex : 'no-bundle');

    // Only show Add To Cart when we're on the absolute final step (upgrades)
    // and either this is not a bundle or we are on the last bundle item.
    if (index === totalSteps - 1 && (!bundle || !bundle.isBundle || bundle.currentIndex === bundle.bundleSize - 1)) {
      $('#addToCartBtn').show();
      $('#nextBtn').hide();
    } else {
      $('#addToCartBtn').hide();
      $('#nextBtn').show();
    }
  
  }

  // Validate only visible fields
  function validateCurrentStep() {
    let valid = true;

    $steps.eq(currentStep).find("input, select, textarea").each(function () {
      if (!validator.element(this)) {
        valid = false;
      }
    });

    return valid;
  }

  // // NEXT BUTTON
  // $(document).on("click", "#nextBtn", function (e) {
  //   e.preventDefault();
  //   if (!validateCurrentStep()) return;

  //   if (currentStep === totalSteps - 1) {
  //     $(this).hide();
  //     $('#addToCartBtn').show();
  //     if ($form.valid()) {
  //       $form.submit();
  //     }
  //     return;
  //   } else {
  //     $('#addToCartBtn').hide();
  //     $(this).show();
  //   }

  //   currentStep++;
  //   showStep(currentStep);
  // });

  $(document).on("click", "#nextBtn", async function (e) {
    e.preventDefault();
    if (!validateCurrentStep()) return;

    const bundle = await getBundleState();
    if (bundle && bundle.isBundle) {
      // Save current snapshot into current index
      const snap = snapshotCurrentCover();
      bundle.items[bundle.currentIndex] = snap;

      // Determine the per-book last content step (the step before the upgrades step).
      // When bundling, we want each book to stop at `totalSteps - 2` and only
      // reveal the absolute upgrades step (`totalSteps - 1`) when the last
      // bundle item is completed.
      const lastContentStep = Math.max(0, totalSteps - 2);

      // If we're on the last content step for the current book
      if (currentStep === lastContentStep) {
        if (bundle.currentIndex < bundle.bundleSize - 1) {
          // Move to next book, start at step 0
          bundle.currentIndex++;
          await saveBundleState(bundle);

           // Show completion popup for the just-completed item
          //  window.showBundleCompletionPopup(bundle.currentIndex - 1, bundle.bundleSize);
           showBundleCompletionMessage(bundle.currentIndex - 1, bundle.bundleSize);
         
           // Load next book after popup delay
           setTimeout(() => {
             // Load saved snapshot for next book (or empty if first time)
             const nextSnap = bundle.items[bundle.currentIndex];
             applySnapshotToForm(nextSnap);
             updateBundleUI(bundle.currentIndex, bundle.bundleSize);

             // Clear the file input so next book starts with clean form
             $(`[data-uploadedImage]:visible`).val('');

             // Reset to step 0 for new book
             currentStep = 0;
             showStep(currentStep);
           }, 500);
           return;
        } else {
          // This was the last book: reveal the upgrades/add-to-cart step
          await saveBundleState(bundle);
          currentStep = totalSteps - 1; // absolute final step
          await showStep(currentStep);
          return;
        }
      } else {
        // Not at the per-book last content step yet, continue within this book
        await saveBundleState(bundle);

        // Compute next step and skip subtitle when disabled. Also ensure we
        // don't advance past the per-book last content step.
        let nextStep = currentStep + 1;
        if (nextStep === 1 && window.customBook && window.customBook.subTitleEnabled === false) {
          $('.subTitle-color-picker-wrapper').hide();
          nextStep = currentStep + 2;
        } else {
          $('.subTitle-color-picker-wrapper').show();
        }
        if (window.customBook && window.customBook.subTitle2Enabled === false) {
          $('.subTitle2-container').hide();
        } else {
          $('.subTitle2-container').show();
        }
        currentStep = Math.min(nextStep, lastContentStep);
        showStep(currentStep);
        return;
      }
    } else {
      // Default non-bundle behavior
      if (currentStep === totalSteps - 1) {
        $(this).hide();
        $('#addToCartBtn').show();
        if ($form.valid()) {
          $form.submit();
        }
        return;
      } else {
        $('#addToCartBtn').hide();
        $(this).show();
      }

      // Compute next step and skip the subtitle step (data-step="1") when
      // subtitle is disabled on the model.
      let nextStep = currentStep + 1;
      if (nextStep === 1 && window.customBook && window.customBook.subTitleEnabled === false) {
        $('.subTitle-color-picker-wrapper').hide();
        nextStep = currentStep + 2;
      } else {
        $('.subTitle-color-picker-wrapper').show();
      }
      if (window.customBook && window.customBook.subTitle2Enabled === false) {
        $('.subTitle2-container').hide();
      } else {
        $('.subTitle2-container').show();
      }
      currentStep = Math.min(nextStep, totalSteps - 1);
      showStep(currentStep);
    }
  });

  // $(document).on("click", "#backBtn", function (e) {
  //   e.preventDefault();
  //   if (currentStep === 0) {
  //     $('.customize-popup__close').trigger('click');
  //     return;
  //   }
  //   currentStep--;
  //   showStep(currentStep);
  // });
  
  $(document).on("click", "#backBtn", async function (e) {
    e.preventDefault();
    const bundle = await getBundleState();
    
    if (bundle && bundle.isBundle) {
      // Save current state before going back
      if (currentStep > 0) {
        // Still within steps of current book, just go to previous step
        bundle.items[bundle.currentIndex] = snapshotCurrentCover();
        await saveBundleState(bundle);

        // Compute previous step and skip subtitle step when disabled.
        let prevStep = currentStep - 1;
        if (prevStep === 1 && window.customBook && window.customBook.subTitleEnabled === false) {
          $('.subTitle-color-picker-wrapper').hide();
          prevStep = currentStep - 2;
        } else {
          $('.subTitle-color-picker-wrapper').show();
        }
        if (window.customBook && window.customBook.subTitle2Enabled === false) {
          $('.subTitle2-container').hide();
        } else {
          $('.subTitle2-container').show();
        }
        currentStep = Math.max(0, prevStep);
        await showStep(currentStep);
        return;
      } else if (bundle.currentIndex > 0) {
        // On step 0, and not first book - go back to previous book's last content step
        bundle.items[bundle.currentIndex] = snapshotCurrentCover();
        bundle.currentIndex--;
        await saveBundleState(bundle);
        
        // Load previous book snapshot
        const prevSnap = bundle.items[bundle.currentIndex];
        applySnapshotToForm(prevSnap);
        updateBundleUI(bundle.currentIndex, bundle.bundleSize);
        
        // Set to last content step of previous book (not final upgrades step)
        const lastContentStep = Math.max(0, totalSteps - 2);
        currentStep = lastContentStep;
        await showStep(currentStep);
        return;
      } else {
        // First book, first step - close customizer
        $('.customize-popup__close').trigger('click');
        return;
      }
    }
    
    // Non-bundle behavior
    if (currentStep === 0) {
      $('.customize-popup__close').trigger('click');
      return;
    }

    // Compute previous step and skip subtitle when disabled.
    let prevStep = currentStep - 1;
    if (prevStep === 1 && window.customBook && window.customBook.subTitleEnabled === false) {
      $('.subTitle-color-picker-wrapper').hide();
      prevStep = currentStep - 2;
    } else {
      $('.subTitle-color-picker-wrapper').show();
    }
    if (window.customBook && window.customBook.subTitle2Enabled === false) {
      $('.subTitle2-container').hide();
    } else {
      $('.subTitle2-container').show();
    }
    currentStep = Math.max(0, prevStep);
    showStep(currentStep);
  });

  showStep(currentStep);
  $(document).on("click", "#addToCartBtn", async function (e) {
    e.preventDefault();
    const $btn = $(this);
    // Prevent double-click
    if ($btn.data('loading')) return;

    // Save original content so we can restore it later
    if (typeof $btn.data('orig-html') === 'undefined') $btn.data('orig-html', $btn.html());

    $btn.data('loading', true);
    $btn.attr('disabled', 'disabled');
    $("#backBtn").attr('disabled', 'disabled');
    $btn.find('[data-total-amount], [data-btn-text], > svg').hide();
    $btn.find('[data-loading-spinner]').show();
    try {
      await addToCartProduct();
      // If addToCartProduct redirects (bundle flow), this code won't run.
    } catch (err) {
      // addToCartProduct already does console.error/alert, but ensure UI restored
      console.error('addToCartProduct failed:', err);
    } finally {
      // Restore button state if still on the page
      $btn.data('loading', false);
      $btn.removeAttr('disabled');
      $("#backBtn").removeAttr('disabled');
    }
  });

  $(document).on('change', 'input[name="product_bundle"]', async function(e){
    e.preventDefault();
    const val = $(this).val();
    const bundleCount = parseInt(val, 10);
    $('form.closer-books-customizer-form input[name="quantity"]').val(val);

    // Only initialize bundle state if count > 1 (actual bundle)
    if (bundleCount > 1) {
      // Initialize bundle state
      const state = await initBundleStateIfNeeded(bundleCount);
      // Show UI indicator: "Customizing 1 of bundleCount"
      updateBundleUI(state.currentIndex, state.bundleSize);
    } else {
      // Not bundle - clear any bundle session (single product)
      await clearBundleState();
      updateBundleUI(null, null); // hide indicator
      // Reset step to 0 for single product
      currentStep = 0;
      await showStep(currentStep);
    }
  });

  $(document).on(`change`, `.variant-picker__form input[type="radio"]`, async function (e) {
    e.preventDefault();
    $(`form.closer-books-customizer-form input[name="id" ]`).val($(this).attr('data-variant-id'));
      initializeBundleState();
      validateCurrentStep();
  });

  $(document).on(`change input`, `#titleInput`, async function (e) {
    e.preventDefault();
    validateCurrentStep();
  });

  const showBundleCompletionMessage = (completedIndex, totalItems) => {
    var $bundleCompletionMessage = $('.bundleCompletionMessage');
    if ($bundleCompletionMessage.length) {
        var itemNumber = completedIndex + 1;
        var message = 'Book ' + itemNumber + ' of ' + totalItems + ' customization completed!';

        // Set message and show
        $('.step-progress').addClass('low-opacity');
        $bundleCompletionMessage.text(message).fadeIn(100);

        // Hide after 3 seconds
        setTimeout(function() {
          $bundleCompletionMessage.fadeOut(100);
        }, 2000);
        setTimeout(function() {
          $('.step-progress').removeClass('low-opacity');
        }, 2002);
    }
  }
  
  // Function to always start from the first step
  async function resetToFirstStep() {
    currentStep = 0;
    await showStep(currentStep);
  }

  window.showStep = showStep;
  window.resetToFirstStep = resetToFirstStep; 
});

// Initialize: Clear bundle state if single product is selected on page load
async function initializeBundleState() {
  const selectedBundle = document.querySelector('input[name="product_bundle"]:checked');
  if (selectedBundle && selectedBundle instanceof HTMLInputElement) {
    const bundleVal = parseInt(selectedBundle.value, 10);
    if (bundleVal <= 1) {
      await clearBundleState();
      updateBundleUI(null, null);
    } else {
      const state = await initBundleStateIfNeeded(bundleVal);
      updateBundleUI(state.currentIndex, state.bundleSize);
    }
  }
}


